import { IntlShape } from "react-intl";
import { ValueTypes } from "../../shared/types";
import { messages } from "../messages";

export const getDefaultFields = (intl: IntlShape) => {
  return [
    {
      value: ValueTypes.rate,
      label: intl.formatMessage(messages.rate),
      isChecked: true
    },
    {
      value: ValueTypes.availability,
      label: intl.formatMessage(messages.availability),
      isChecked: true
    },
    {
      value: ValueTypes.closed,
      label: intl.formatMessage(messages.closed),
      isChecked: true
    }
  ];
};